import {
  Input,
  Label,
  Legend,
  Text
} from "@gjensidige/builders-components";
import React, { useEffect } from "react";
import {
  IConsentCheckBoxProps
} from "../../interfaces/EnquiryInterface";
import { HelpText } from "./HelpText";
export const EnquiryOptionConsentCheckBox: React.FC<IConsentCheckBoxProps> = (
  props: IConsentCheckBoxProps
) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    props.handleChange(props.questionType, "", true, value);
  };

  return (
    <>
      {props.helpText && (
        <HelpText
          labelText={props.labelText}
          message={props.helpText}
          helpTextClassName="help-text-wrapper"
          referenceId={props.questionType}
        />
      )}
      {props.labelText && !props.helpText && (
        <Legend className="enquiry-group-label">{props.labelText}</Legend>
      )}
      {props.labelDescription && (
        <Text size="body"> {props.labelDescription} </Text>
      )}
      {props.terms && (       
         <ul className="enquiry-group-list">
         {props.terms.map((item, index) => (
           <li key={index}>
            <Text size="body">{item}</Text>
           </li>
         ))}
        </ul>       
       )}
      <Label className= 'enquiry-justify-content'>
        <Input
          id={props.questionType}
          name={`${props.questionType}-options`}
          onChange={handleChange}
          type="checkbox"
          tracking={false}
          checked={props.isChecked}
        />
         <Text className="enquiry-checkbox-label" >{props.checkboxText}</Text>
      </Label>
    </>
  );
};
